/*
 * Copyright (c) 2020  Apricot Courses, LLC. All Rights Reserved.
 */

import { title, container } from "assets/jss/material-kit-pro-react.jsx";
import { brand } from "../apricot.jsx";
import { niceScrollbar } from "assets/jss/views/classroomPage/classroomStyle.jsx";

const mainImg = require("assets/img/desk2.jpg");

export const dlgTitle = {
  fontSize: "1.2rem",
  color: "white",
  height: "4rem",
  padding: "0 1rem",
};

export const studyDlg = {
  minHeight: "85vh",
  minWidth: "60vw",
  "@media (max-width: 1024px)": {
    minWidth: "75vw",
  },
  borderRadius: "12px",
};

export const titleText = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  margin: "0.5rem",
};

const styles = (theme) => {
  const title = { ...title, fontFamily: theme.typography.fontFamily };

  return {
    "@global": niceScrollbar,

    title: {
      ...title,
      marginTop: "3rem",
      color: "#FFFFFF !important",
    },
    container: { ...container, position: "relative" },
    brand,

    myStudy: {
      overflow: "auto",
      backgroundImage: `url(${mainImg})`,
      backgroundSize: "cover",
      height: "100vh",
      width: "100%",
      postion: "absolute",
      top: 0,
    },

    studyPanel: {
      position: "absolute",
      top: "20vh",
      right: 0,
      width: "100%",
      display: "grid",
      gridTemplateRows: "100%",
      "@media (min-width: 1024px) and (orientation: landscape)": {
        gridTemplateColumns: "repeat(3, 1fr)",
        gridTemplateAreas: "'x y list'",
      },
      gridTemplateColumns: "1fr",
      gridTemplateAreas: "'list'",
    },

    studyListV: {
      gridArea: "list",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      "@media (max-width: 1023px) and (orientation: landscape)": {
        display: "none",
      },
    },

    studyListH: {
      gridArea: "list",
      "@media (max-width: 1023px) and (orientation: landscape)": {
        display: "block",
      },
      display: "none",
    },

    listItem: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "12px",
      // small landscape, show 2 rows, 3 columns
      "@media (max-width: 1023px) and (orientation: landscape)": {
        width: "100%",
        minHeight: "4rem",
        fontSize: "1.5rem",
      },
      // larger width (most likely landscape)
      "@media (min-width: 1025px)": {
        minHeight: "10vh",
        fontSize: "4vh",
      },
      // for tablet in portrait
      "@media (min-width: 768px) and (orientation: portrait)": {
        minHeight: "10vh",
        fontSize: "4vh",
        width: "50%",
        marginTop: "2vh",
      },
      minHeight: "4rem",
      fontSize: "1.6rem",
      width: "75%",
      marginTop: "1rem",

      color: "white",
      opacity: 0.9,
      cursor: "pointer",
      fontWeight: 300,
      "&:hover": {
        opacity: 1,
        boxShadow:
          "0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2);",
        fontWeight: 500,
      },
    },

    courseCard: {
      margin: "1rem 0",
      borderRadius: "8px",
      display: "flex",
    },

    cardMedia: {
      "@media (min-width: 640px)": {
        "@media (min-width: 1600px)": {
          minHeight: "7rem",
          width: "12.6rem",
        },
        minHeight: "5rem",
        width: "9rem",

        display: "block",
      },
      display: "none",
    },

    crsLabel: {
      width: "100%",
      padding: "0 1rem",
      display: "flex",
      alignItems: "center",
      "@media (min-width: 1600px)": {
        fontSize: "2rem",
        minHeight: "7rem",
      },
      fontSize: "1.5rem",
      minHeight: "5rem",
    },

    lecLabel: {
      margin: "0 0 1rem 2rem",
      cursor: "pointer",
      padding: 0,
      display: "flex",
      alignItems: "center",
    },

    lecTitle: {
      "@media (min-width: 1600px)": {
        fontSize: "1.7rem",
      },
      fontSize: "1.2rem",
      lineHeight: "120%",
    },

    lecBullet: {
      marginRight: "0.5rem",
      minWidth: "0.7rem",
      height: "0.7rem",
    },

    dlgTitle,
    studyDlg,
    titleText,
  };
};

export default styles;
